import { mapBaseVideo } from './BaseVideo.mappers';
export const mapVideo = (file, baseFile) => {
  var _file$media;
  const baseVideo = mapBaseVideo(file, baseFile);
  const resolutions = ((_file$media = file.media) == null || (_file$media = _file$media.video) == null ? void 0 : _file$media.resolutions) || [];
  return {
    mediaType: 'video',
    ...baseVideo,
    height: 0,
    width: 0,
    videoPreviewUrls: resolutions.map(r => r.url || '')
  };
};
//# sourceMappingURL=Video.mappers.js.map